// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Escalator-module__container___wye88 {
    position: relative;
    display: inline-block;
    height: 510px;
    width: auto;
    aspect-ratio: 370/500;

    transform: perspective(2000px);
    transition: all 0.3s ease;
    /* Add depth to the whole panel */
    box-shadow: 
        -20px 20px 30px rgba(0, 0, 0, 0.2),
        -5px 5px 15px rgba(0, 0, 0, 0.1),
        inset 2px -2px 5px rgba(255, 255, 255, 0.2);
}

.Escalator-module__backgroundImage___qCc2B {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;

    background: linear-gradient(
        105deg,
        rgba(255, 255, 255, 0.2) 0%,
        rgba(255, 255, 255, 0) 40%
    );
}

.Escalator-module__overlayImage___Zv1Au,
.Escalator-module__overlayVideo___VSfpb {
    position: absolute;
    top: 5%;
    left: 6.5%;
    width: 87.1%;
    height: 91%;
    object-fit: cover;
}
`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/Panels/Escalator/Escalator.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,WAAW;IACX,qBAAqB;;IAErB,8BAA8B;IAC9B,yBAAyB;IACzB,iCAAiC;IACjC;;;mDAG+C;AACnD;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;;IAEnB;;;;KAIC;AACL;;AAEA;;IAEI,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB","sourcesContent":[".container {\n    position: relative;\n    display: inline-block;\n    height: 510px;\n    width: auto;\n    aspect-ratio: 370/500;\n\n    transform: perspective(2000px);\n    transition: all 0.3s ease;\n    /* Add depth to the whole panel */\n    box-shadow: \n        -20px 20px 30px rgba(0, 0, 0, 0.2),\n        -5px 5px 15px rgba(0, 0, 0, 0.1),\n        inset 2px -2px 5px rgba(255, 255, 255, 0.2);\n}\n\n.backgroundImage {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n\n    background: linear-gradient(\n        105deg,\n        rgba(255, 255, 255, 0.2) 0%,\n        rgba(255, 255, 255, 0) 40%\n    );\n}\n\n.overlayImage,\n.overlayVideo {\n    position: absolute;\n    top: 5%;\n    left: 6.5%;\n    width: 87.1%;\n    height: 91%;\n    object-fit: cover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Escalator-module__container___wye88`,
	"backgroundImage": `Escalator-module__backgroundImage___qCc2B`,
	"overlayImage": `Escalator-module__overlayImage___Zv1Au`,
	"overlayVideo": `Escalator-module__overlayVideo___VSfpb`
};
export default ___CSS_LOADER_EXPORT___;
